import React, { forwardRef } from 'react';
import { BoxTab as BoxTabNew } from './BoxTab';
import { convertOldBoxTabProps } from './converter.old';
import type { OldBoxTabProps } from './converter.old';

export type BoxTabProps = OldBoxTabProps;

export const BoxTab = forwardRef<HTMLDivElement, BoxTabProps>((props, ref) => (
  <BoxTabNew {...convertOldBoxTabProps(props)} ref={ref} />
));

BoxTab.displayName = 'BoxTab';
